import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ConfigProvider } from "antd";
import deDE from "antd/locale/de_DE";
import enUS from "antd/locale/en_US";
import frFR from "antd/locale/fr_FR";
import itIT from "antd/locale/it_IT";
import RouteRegisterer from "./routes/";
import "../styles.scss";
import CommonAction from "stores/common/CommonAction";
import i18n from "../i18n";
import environment from "environment";

const localeByLanguage = {
  English: enUS,
  German: deDE,
  French: frFR,
  Italian: itIT,
};

const languageCodeByLanguage = {
  English: "en",
  German: "de",
  French: "fr",
  Italian: "it",
};

const App = () => {
  const dispatch = useDispatch();
  const currentLanguage = useSelector((state) => state.common.currentLanguage);

  function getInitialLanguage() {
    const env = environment.APP_ENVIRONMENT;
    if (
      env === "eponaDevelopment" ||
      env === "eponaTesting" ||
      env === "eponaProduction"
    ) {
      return "French";
    }
    if (env === "alabusTesting") {
      return "English";
    }
    return "German";
  }
  
  useEffect(() => {
    const value = getInitialLanguage();
    if (value === "German") {
      dispatch(CommonAction.setCurrentLanguage("German"));
      i18n.changeLanguage("de");
    } else if (value === "English") {
      dispatch(CommonAction.setCurrentLanguage("English"));
      i18n.changeLanguage("en");
    } else if (value === "French") {
      dispatch(CommonAction.setCurrentLanguage("French"));
      i18n.changeLanguage("fr");
    } else if (value === "Italian") {
      dispatch(CommonAction.setCurrentLanguage("Italian"));
      i18n.changeLanguage("it");
    }
  }, [dispatch]);

  useEffect(() => {
    document.documentElement.lang =
      languageCodeByLanguage[currentLanguage] || "en";
  }, [currentLanguage]);

  return (
    <ConfigProvider locale={localeByLanguage[currentLanguage] || enUS}>
      <div>
        <RouteRegisterer />
      </div>
    </ConfigProvider>
  );
};

export default App;
